import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function LanguageSwitcher({ variant = "light" }: { variant?: "light" | "dark" }) {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage?.startsWith("en") ? "en" : "it";
  const change = (lng: "it" | "en") => {
    void i18n.changeLanguage(lng);
    // Persistence (localStorage + cookie + <html lang>) is handled centrally
    // by the languageChanged listener in src/lib/i18n/index.ts.
  };
  const triggerClass =
    variant === "dark"
      ? "ios-tap inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-[12px] font-medium text-white hover:bg-white/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
      : "ios-tap inline-flex items-center gap-1.5 rounded-full border border-border bg-background px-3 py-1.5 text-[12px] font-medium text-foreground hover:bg-muted";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={triggerClass} aria-label={`${t("language.label")}: ${current.toUpperCase()}`}>
        <Globe className="h-3.5 w-3.5" aria-hidden="true" />
        <span className="uppercase">{current}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        <DropdownMenuItem onClick={() => change("it")} className={current === "it" ? "font-semibold" : ""}>
          🇮🇹 {t("language.it")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => change("en")} className={current === "en" ? "font-semibold" : ""}>
          🇬🇧 {t("language.en")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
